import { Pipe, PipeTransform } from '@angular/core';
import { InstallationIncotermsPluginService } from './incoterms.service';
@Pipe({
    name: 'incoterms',
    standalone: false
})
export class IncotermsStatusPipe implements PipeTransform {
  public incoterms: any[];
  constructor(private service: InstallationIncotermsPluginService) {
    this.incoterms = this.service.getIncoterms();
  }
  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.incoterms);
  }
}
